module.exports = __webpack_public_path__ + "../../../vue-resources/personal-account/dist/img/contract_black.png";